import { createSelector } from 'reselect';

const withdrawalWizardSelector = (state) => state.order.withdrawalWizard;

export const selectWithdrawalWizardErrorMessage = createSelector(
  withdrawalWizardSelector,
  (state) => state.errorMessage,
);
